import countWords from '../../../../shared/countWords';

const WordCount = ({ content }: { content: string }) => {
  return <>{countWords(content)}</>;
};
export default WordCount;
